import React from "react";


export default function Footer() {
  return (
    <footer>
      <p>Jupiter Deals © Copyright {new Date().getFullYear()}</p>
    </footer>
  );
}
